import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import PaymentPageHeaderService from "../PaymentPageHeader/PaymentPageHeaderService";
import { API_BASEURLICON } from "../../Config";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const isLoggedIn =
    sessionStorage.getItem("session") && sessionStorage.getItem("sessionID");
  const { handleLogout } = PaymentPageHeaderService();
  const imageUrl = API_BASEURLICON;

  return (
    <>
      <nav>
        <div className="logo">
          <span
            className="hamburger"
            onClick={() => setMenuOpen(!menuOpen)}
            style={{ cursor: "pointer" }}
          >
            ☰
          </span>
          <img
            src={`${imageUrl}Image/Website/1/B2C-whitelogo.png`}
            alt="Pocketvila Logo"
          />
        </div>

        <div className={`menu ${menuOpen ? "open" : ""}`} id="menu">
          <NavLink to="/" onClick={() => setMenuOpen(false)}>
            Home
          </NavLink>
          <NavLink to="/" onClick={() => setMenuOpen(false)}>
            About
          </NavLink>
          <NavLink to="/" onClick={() => setMenuOpen(false)}>
            Business
          </NavLink>
          <NavLink to="/" onClick={() => setMenuOpen(false)}>
            Career
          </NavLink>
          <NavLink to="/" onClick={() => setMenuOpen(false)}>
            Contact
          </NavLink>
          <NavLink to="/" onClick={() => setMenuOpen(false)}>
            Blogs
          </NavLink>
        </div>

        {/* <NavLink to="/login" className="login-btn">
          Login
        </NavLink> */}
        {isLoggedIn ? (
          <span
            className="login-btn"
            onClick={handleLogout}
            style={{ cursor: "pointer" }}
          >
            Logout
          </span>
        ) : (
          <NavLink to="/login">
            <span className="login-btn">Login</span>
          </NavLink>
        )}
      </nav>
    </>
  );
};

export default Header;
